'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var AutoCompleteList = require('../AutoCompleteList/AutoCompleteList.js');

const WithDivider = ({ children })=>{
    const childArray = react.Children.toArray(children).filter(Boolean);
    return jsxRuntime.jsx(jsxRuntime.Fragment, {
        children: childArray.map((child, index)=>{
            const isLastItem = childArray.length - 1 === index;
            return jsxRuntime.jsxs(react.Fragment, {
                children: [
                    child,
                    !isLastItem && jsxRuntime.jsx(AutoCompleteList.Divider, {})
                ]
            }, index);
        })
    });
};

exports.WithDivider = WithDivider;
